<wdpr-single-select
    class="control"
    [finderControlErrorClass]="errorControlClass"
    [showError]="showError"
    [controlError]="controlError"
    [disabled]="disabled"
    [id]="id"
    [options]="options"
    [value]="value"
    [label]="label"
    [hidden]="hidden"
    (item-selected)="onChange($event)"
></wdpr-single-select>
